<template>
    <div class="ur-date-picker ur-date-picker-range ur-date-time-range-picker ur-input" :class="$_class">
        <div class="ur-date-picker-wrapper" :class="wrapperClass">
            <ur-text-field ref="concat-text" class="ur-date-picker__text-field ur-date-time-range-picker__text-field-one-input" v-if="oneInputMode"
                           v-model="concatTextInput"
                           :mask="$_concatInputMask"
                           :placeholder="noPlaceholder?'':(inputType.toUpperCase() + ' HH:II:SS AM/PM' + ' ~ ' + inputType.toUpperCase() + ' HH:II:SS AM/PM')"
                           :disabled="disabled"
                           :no-shake="noShake"
                           tabindex="-1"
                           @focus="onFocus(1, $event)"
                           @enter="onUpdateConcat"
                           @keyup.ctrl.86="onUpdateConcat"
                           @keydown.tab="(e)=>onUpdateConcat(e)"/>
            <template v-else>
                <ur-text-field ref="from-text" class="ur-date-picker__text-field ur-date-time-range-picker__text-field"
                            v-model="from.textInput"
                            :mask="inputType.replace(/#/g,'%#').replace(/[ymd]/gi,'#') + ' ##:##:## AA'"
                            :placeholder="noPlaceholder?'':inputType.toUpperCase()"
                            :disabled="disabled"
                            :no-shake="noShake"
                            @focus="onFocus(1)"
                            @enter="onUpdate(1)"
                            @keyup.ctrl.86="onUpdate(1)"
                            @keydown.tab="(e)=>onUpdate(1,e)"
                            @keydown.up.prevent="e => selectedValueUp(e, 'from')"
                            @wheel.prevent.stop="e => mouseWheel(e, 'from')"
                            @keydown.down.prevent="e => selectedValueDown(e, 'from')"/><!--
             --><ur-icon-wrapper class="ur-date-picker__icon-wrapper" :class="iconWrapperClass" @click.native="onClickIcon(1)">
                    <ur-icon class="ur-date-picker__icon" icon="calendar"></ur-icon>
                </ur-icon-wrapper>
                <ur-icon-wrapper>
                    ~
                </ur-icon-wrapper>
                <ur-text-field ref="to-text" class="ur-date-picker__text-field ur-date-time-range-picker__text-field" id="aaa"
                            v-model="to.textInput"
                            :mask="inputType.replace(/#/g,'%#').replace(/[ymd]/gi,'#') + ' ##:##:## AA'"
                            :placeholder="noPlaceholder?'':inputType.toUpperCase()"
                            :disabled="disabled"
                            :no-shake="noShake"
                            tabindex="-1"
                            @focus="onFocus(2)"
                            @enter="onUpdate(2)"
                            @keyup.ctrl.86="onUpdate(2)"
                            @keydown.tab="(e)=>onUpdate(2,e)"
                            @keydown.up.prevent="e => selectedValueUp(e, 'to')"
                            @wheel.prevent.stop="e => mouseWheel(e, 'to')"
                            @keydown.down.prevent="e => selectedValueDown(e, 'to')"/>
            </template><!--
         --><ur-icon-wrapper v-if="oneInputMode" class="ur-date-picker__icon-wrapper" :class="iconWrapperClass" @click.native="onClickIcon(1)">
                <ur-icon class="ur-date-picker__icon" icon="calendar"></ur-icon>
            </ur-icon-wrapper>
            <ur-icon-wrapper v-else class="ur-date-picker__icon-wrapper" :class="iconWrapperClass" @click.native="onClickIcon(2)">
                <ur-icon class="ur-date-picker__icon" icon="calendar"></ur-icon>
            </ur-icon-wrapper>
            <div v-if="messageShow" :style="$_messageStyle()"
                class="ur-date-picker__message ur-validator__message"
                :class="messageClass">{{messageShow}}</div>
        </div>
        <ur-segment-wrapper v-if="preset" :disabled="disabled" v-model="presetName" v-bind="segmentWrapperBind" class="ur-date-picker__segment-wrapper">
            <template v-for="(item,idx) in customPreset">
                <ur-segment-button :value="item.action"
                                   :key="idx"
                                   @click.stop="onClickSegment(item.action)"><!--
                     -->{{item.label}}<!--
                 --></ur-segment-button>
            </template>
        </ur-segment-wrapper>

        <div class="ur-date-picker__calendar ur-date-picker__calendar--range" :class="calendarClass"
                ref="floating" v-ur-attach-root v-click-outside.anchor="onClickOutside">
            <div class="ur-date-picker__calendar__month-area">
                <ur-icon-wrapper @click.native.stop="onClickPrevMonth(showFlag)">
                    <ur-icon icon="expand_menu" ></ur-icon>
                </ur-icon-wrapper>
                <span>
                    {{monthFilter(calendarMonth,1)}}
                </span>
                -
                <span>
                    {{monthFilter(calendarMonth,2)}}
                </span>

                <ur-icon-wrapper @click.native.stop="onClickNextMonth(showFlag)">
                    <ur-icon icon="collapse_menu" ></ur-icon>
                </ur-icon-wrapper>
            </div>
            <div :class="timepickerClass">
                <ur-time-picker v-model="from.time.selected"
                                :meridiem="from.time.meridiem"
                                :mode="timepickerMode"
                                :term="term"
                                :contain-mrdm="containMrdm"
                                @input="onSelectedTime()"/>
                <ur-time-picker v-model="to.time.selected"
                                :meridiem="to.time.meridiem"
                                :mode="timepickerMode"
                                :term="term"
                                :contain-mrdm="containMrdm"
                                @input="onSelectedTime()"/>
            </div>
            <div class="ur-date-picker__calendar__range-container">
                <div class="ur-date-picker__calendar__date-area">
                    <div class="ur-date-picker__calendar__day ur-date-picker__calendar__row">
                        <div class="ur-date-picker__calendar__row-background"></div>
                        <div class="ur-date-picker__calendar__row-content">
                            <template v-for="(day, idx) in weekDay">
                                <span :key="idx" :class="weekDayClass(idx)">{{day.text}}</span>
                            </template>
                        </div>

                    </div>
                    <div class="ur-date-picker__calendar__date-wrapper" @mouseleave="hoverDate=''">
                        <template v-for="(week,wIdx) in monthCalendar(calendarMonth,1)">
                            <div :key="wIdx" class="ur-date-picker__calendar__week ur-date-picker__calendar__row">
                                <div class="ur-date-picker__calendar__row-background">
                                    <template v-for="(date,dIdx) in week">
                                        <div :key="dIdx" :class="date.rangeColor"></div>
                                    </template>
                                </div>
                                <div class="ur-date-picker__calendar__row-content">
                                    <template v-for="(date,dIdx) in week">
                                        <span :key="dIdx"
                                              :class="dateClass(date,dIdx)"
                                              @click.stop="onClickDate(date)"
                                              @mouseenter="hoverDate=date.value">{{date.text}}</span>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="ur-date-picker__calendar__divider"></div>
                <div class="ur-date-picker__calendar__date-area">
                    <div class="ur-date-picker__calendar__day ur-date-picker__calendar__row">
                        <div class="ur-date-picker__calendar__row-background"></div>
                        <div class="ur-date-picker__calendar__row-content">
                            <template v-for="(day, idx) in weekDay">
                                <span :key="idx" :class="weekDayClass(idx)">{{day.text}}</span>
                            </template>
                        </div>
                    </div>
                    <div class="ur-date-picker__calendar__date-wrapper" @mouseleave="hoverDate=''">
                        <template v-for="(week,wIdx) in monthCalendar(calendarMonth,2)">
                            <div :key="wIdx" class="ur-date-picker__calendar__week ur-date-picker__calendar__row">
                                <div class="ur-date-picker__calendar__row-background">
                                    <template v-for="(date,dIdx) in week">
                                        <div :key="dIdx" :class="date.rangeColor"></div>
                                    </template>
                                </div>
                                <div class="ur-date-picker__calendar__row-content">
                                    <template v-for="(date,dIdx) in week">
                                            <span :key="dIdx"
                                                  :class="dateClass(date, dIdx)"
                                                  @click.stop="onClickDate(date)"
                                                  @mouseenter="hoverDate=date.value">{{date.text}}</span>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <ur-action-bar class="ur-date-picker__action-bar">
                <template v-slot:left>
                    <ur-button tabindex="-1" sm borderless @click.native.stop="onClickCancel">{{cancelLabel}}</ur-button>
                </template>
                <ur-button v-if="!autoConfirm" tabindex="-1" sm main @click.native.stop="onConfirm">{{confirmLabel}}</ur-button>
            </ur-action-bar>
        </div>
    </div>
</template>

<script>
    import urValidatorMixin from '../../../mixins/urValidator/urValidatorMixin.vue';

    const DUMMY_EVENT = {
        preventDefault: ()=>{}
    };
    // ur-date-time-range-picker는 년/월/일/시/분/오전오후 를 범위 선택하기 위한 시각적 표현을 제공합니다.
    // #The ur-date-time-range-picker provides a visual representation for range selection of year/month/day/hour/minute/afternoon.
    export default {
        // TODO: validator를 넣어놓긴했는데 message띄우는 영역 설정을 안했네요.. ur-radio-wrapper등을 참고하여 메시지를 넣고 css설정을 해주시면 되겠습니다.
        // rules를 통합으로 넣을지 fromRules, toRules, rules 세가지를 사용하고 fromValidate->toValidate->validate 순서로 validate를 할지 고민하다가 결론을 못내고 미루다가 깜빡했나봐요
        // TODO: dropdown, datepicker 같이 클릭했을 때 위로 뜨는 창이 생기는 경우 ur-tooltip 혹은 v-ur-tooltip처럼 wrapper의 overflow설정에 영향을 안받으면서 뜰 수 있도록 설정을...
        // 1~2월중에 하려고는 했었는데 미루다가 못했습니다 ㅠ
        name: 'ur-date-time-range-picker',
        mixins: [urValidatorMixin],
        inject: {
            urInput: {from:'urInput', default: () => undefined}
        },
        props: {
            // $ver: v0.1.2
            // $v-model
            // 선택된 date range를 나타내는 값입니다. model-type props의 설정에 따라 range로 반환됩니다.
            // 해당 타입의 값을 element로 하는 length 2의 Array형태로 반환됩니다.
            // 형식에 맞지 않는 데이터가 입력될 경우 빈값(['',''])으로 변경될 수 있습니다.
            // #A value representing the selected date or date range. Depending on the model-type props setting,
            // #it is returned as range.
            // #it is returned as an Array of length 2 whose value is the element.
            // #If incorrect data is entered, it may be changed to empty value (['', '']).
            // $tags IDE, value
            value: {
                type: Array,
                default:() => ['','']
            },
            // $ver: v2.1.2
            // 기간 선택시 자동 입력 여부입니다. true 일 경우 달력에서 기간 선택 완료시 confirm 을 누르지 않아도 자동으로 입력됩니다.
            // #Whether to enter automatically when selecting a period. If true, it is automatically entered when the period is selected in the calendar without pressing confirm.
            // $default: false
            autoConfirm: {
              type:Boolean,
              default: false
            },
            // $ver: v0.1.2
            // text-field영역에 입력되는 date-format입니다.
            // YY,YYYY,MM,DD와 특수문자등을 포함한 문자열로 설정할 수 있습니다.
            // 만약 MM/DD/YY를 inputType으로 설정한다면 text-field에 날짜 입력시에도
            // 동일 순서로 일,월,년도 순으로 입력해야합니다.
            // #The date-format entered in the text-field area.
            // #Can be set to a string containing YY, YYYY, MM, DD and special characters.
            // #If MM / DD / YY is set as inputType, even when entering date in text-field
            // #You must enter the date, month, year in the same order.
            // $tags IDE, inputType
            inputType: {
                type: String,
                default: 'YYYY-MM-DD',
                validator: (val) => {
                    return /^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(val)
                        && val.match(/y{1,4}/gi).length === 1
                        && val.match(/m{1,2}/gi).length === 1
                        && val.match(/d{1,2}/gi).length === 1;
                }
            },
            // $ver: v0.1.2
            // v-model로 반환될 date-format입니다.
            //'array'([YYYY,MM,DD]) 혹은 input-type과 동일하게 YY,YYYY,MM,DD와 특수문자등을
            // 포함한 문자열로 설정할 수 있습니다.
            // #Like 'array' ([YYYY, MM, DD]) or input-type,
            // #it can be set to a string including YY, YYYY, MM, DD and special characters.
            // $tags IDE, modelType
            modelType: {
                type: String,
                default: 'YYYY-MM-DD',
                validator: (val) => {
                    if(/^(date|array)$/i.test(val)) {return true;}
                    return /^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(val)
                        && val.match(/y{1,4}/gi).length === 1
                        && val.match(/m{1,2}/gi).length === 1
                        && val.match(/d{1,2}/gi).length === 1;
                }
            },
            // $ver: v0.1.2
            // 컴포넌트가 created되는 시점에 v-model의 초기값을 설정할 수 있습니다.<br>
            // 'none': default값으로, 아무런 설정을 하지 않습니다. 원래의 v-model값을 그대로 사용합니다.<br>
            // 'clear': v-model값을 ['','']로 설정합니다.<br>
            // 'today': v-model값을 오늘~오늘로 설정합니다.<br>
            // 그 외에 자유롭게 특정일 혹은 특정기간을 설정할 수 있습니다. {unit}에는 'day', 'week', 'month', 'year'이 사용됩니다.<br>
            // '{unit}+?': 오늘~해당일로 설정합니다.<br>
            // '{unit}-?': 해당일~오늘로 설정합니다.<br>
            // #You can set the initial value of v-model when the component is created. <br>
            // #'none': This is the default value and no setting is done. Accept the original v-model value. <br>
            // #'clear': Set the v-model value to ['', '']. <br>
            // #'today': Set today to today. <br>
            // #In addition, you can freely set a specific date or period. {unit} uses 'day', 'week', 'month', and 'year'. <br>
            // #'{unit} +?': Set it as today ~ the day. <br>
            // #'{unit}-?': Set it from today to today. <br>
            // $tags IDE, init
            init:{
                type:String,
                default: 'none',
                validator: (val) => {
                    return /^(none|clear|today|day[+-][0-9]+|week[+-][0-9]+|month[+-][0-9]+|year[+-][0-9]+)$/i.test(val);
                }
            },
            // $ver: v0.1.2
            // YYYY-MM-DD의 형식으로 선택가능한 minimum date를 설정할 수 있습니다.
            // #You can set a selectable minimum date in the format YYYY-MM-DD.
            // $tags IDE, minDate
            minDate: {
                type: String,
                default: '1970-01-01',
                validator: (val) => {
                    return /^(19[7-9][0-9]|[2-9][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(val);
                }
            },
            // $ver: v0.1.2
            // YYYY-MM-DD의 형식으로 선택가능한 maximum date를 설정할 수 있습니다.
            // #You can set a selectable maximum date in the format YYYY-MM-DD.
            // $tags IDE, maxDate
            maxDate: {
                type: String,
                default: '9999-12-31',
                validator: (val) => {
                    return /^(19[7-9][0-9]|[2-9][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(val);
                }
            },
            // $ver: v0.1.2
            // range 혹은 strictRange를 true로 주면 date-range를 선택할 수 있습니다.
            // strict-range가 false인 경우 시작일 혹은 종료일이 빈값으로 설정될 수 있으나
            // strict-range가 true인 경우 시작일과 종료일이 둘 다 선택되어야 v-model값이 업데이트 됩니다.
            // #If you set range or strictRange to true, you can select a date-range.
            // #If strict-range is false, the start date or end date can be set to an empty value.
            // #If strict-range is true, the v-model value will not be updated until both start date and end date are selected.
            // $default: false
            strictRange: {
                type:Boolean,
                default: false
            },
            // $ver: v0.2.0
            // <em>ur-date-picker</em>우측으로 프리셋 버튼을 생성합니다.
            // {label: String, action: String}을 element로 갖는 Array이며 각각의 element는 하나의 segment-button을 의미합니다.
            // 기본값으로 today, week-1, month-1 값을 설정해두었습니다.
            // label은 segment-button에 표시되는 text이고,
            // action은 init props와 동일한 형식으로 'clear', 'today', '{unit}[+-]?'등의 값을 사용합니다.
            // #<em>ur-date-picker</em> Create a preset button to the right.
            // #{label: String, action: String} An Array with elements, each element representing one segment-button.
            // #label is the text displayed in the segment-button, and action uses the same format as init props, with values ​​such as 'clear', 'today', '{unit} [+-]?'.
            customPreset: {
                type:Array,
                validator: (arr) => {
                    return arr.every((item)=>{
                        return item.label && /^(clear|today|day[+-][0-9]+|week[+-][0-9]+|month[+-][0-9]+|year[+-][0-9]+)$/.test(item.action)
                    })
                },
                default: () => [
                    {label:'today',action:'today'},
                    {label:'a week',action:'week-1'},
                    {label:'a month',action:'month-1'}
                ]
            },

            // $ver: v0.2.0
            // 프리셋 버튼 활성화 여부입니다.
            // #Whether to handle preset deactivation
            // $default: false
            // $tags IDE, preset
            preset: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // text-field영역의 placeholder는 기본적으로 input-type이 형식에 따라 적절한 placeholder를 갖지만
            // no-placeholder 옵션을 통해 placeholder를 표시하지 않을 수 있습니다.
            // #Placeholders in the text-field area have an appropriate placeholder by default,
            // #although the input-type has a proper placeholder, but the no-placeholder option may not display the placeholder.
            // $default: false
            noPlaceholder: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // preset props설정으로 생기는 <em>ur-segment-wrapper</em>에 추가적인 옵션을 주고싶다면
            // segment-wrapper-bind에 object 타입으로 props 및 class, style등을 전달할 수 있습니다.
            // #If you want to add additional options to the <em>ur-segment-wrapper</em> resulting from the preset props configuration,
            // #you can pass props, class and style as object types to the segment-wrapper-bind.
            segmentWrapperBind: {
                type: Object,
                default: () => {}
            },
            // $ver: v0.2.2
            // 하나의 input으로 표현할지 여부입니다.
            // #Whether to display as one input.
            oneInputMode: {
                type: Boolean,
                default: false
            },

            // $ver: v0.2.0
            // 크기 입니다. 'medium','small' 두 가지 중 하나를 입력해야 합니다.
            // #The size You must enter one of two types: medium or small.
            // $default: medium
            // $tags IDE, size
            size: {
                validator: function (value) {
                    // The value must match one of these strings
                    return ['medium', 'small'].indexOf(value) !== -1
                },
                // type: String,
                // default: 'medium',
            },

            // $ver: v0.1.2
            // medium 크기의 date-picker를 사용합니다. calendar의 크기는 변하지 않습니다.
            // #Use a medium size date-picker. The size of the calendar does not change.
            // $default: false
            medium: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: medium
            md: {type: Boolean},
            // $ver: v0.1.2
            // small 크기의 date-picker를 사용합니다. calendar의 크기는 변하지 않습니다.
            // #Use a small size date-picker. The size of the calendar does not change.
            // $default: false
            small: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: small
            sm: {type: Boolean},
            // $ver: v0.2.0
            // calendar영역의 cancel button에 들어갈 text를 설정할 수 있습니다. 다국어 처리를 위해 만들었습니다.
            // #You can set the text for the cancel button in the calendar area. Created for multilingual processing.
            cancelLabel: {
                type:String,
                default: 'Cancel'
            },
            // $ver: v0.1.2
            // calendar영역의 confirm button에 들어갈 text를 설정할 수 있습니다. 다국어 처리를 위해 만들었습니다.
            // #You can set the text for the confirm button in the calendar area. Created for multilingual processing.
            confirmLabel: {
                type: String,
                default: 'Confirm'
            },

            // $ver: v0.1.x
            // 미완성
            // $hide
            guideMessage: {type:String, default: undefined},
            // $ver: v0.1.x
            // 미완성
            // $hide
            successMessage: {type:String, default: undefined},
            timepickerMode: {type:String, default: 'stepper'},
            // $ver: v0.2.1
            // Time Picker가 Dropdown 형태일 시에 분(minute)의 텀.
            // #Defined dropdown type time(minute) term.
            // $default: 30
            // $tags IDE, term
            term: {
                type:[Number, String],
                default: 30,
                validator: function (value) {
                    // The value must match one of these strings
                    return [1,5,10,30,60,'1','5','10','30','60'].indexOf(value) !== -1
                },
            },

            // $ver: v0.2.1
            // 시간의 오전 오후 표시 여부입니다.
            // #Whether it is displayed in the morning/afternoon.
            // $default: false
            // $tags IDE, term
            containMrdm: {
                type:Boolean,
                default: false,
            },

            // $ver: v0.2.x
            // 안내메시지 표현 형태 속성입니다. 'heavy', 'light' 속성을 지정할 수 있습니다.
            // #Announcement appearance attributes. You can specify the 'heavy' and 'light' attributes.
            messageStyle: {
                type: String,
                validator: function(value) {
                    return ['heavy', 'light'].indexOf(value) !== -1;
                },
                default: 'heavy'
            }
            /* [FROM VALIDATOR] */
            // rules
            // disabled
            // lazy
            // noShake
            /********************/
        },
        data() {return {
            wheelEvent: true,
            default: {
                size: 'medium'
            },
            weekDay: [
                {text:'S', value: 'SUN'},
                {text:'M', value: 'MON'},
                {text:'T', value: 'TUE'},
                {text:'W', value: 'WED'},
                {text:'T', value: 'THU'},
                {text:'F', value: 'FRI'},
                {text:'S', value: 'SAT'}
            ],
            monthAbbr: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],

            today: '', // YYYY-MM-DD
            currTime: {}, // Date object

            // if user changes textInput, set selected same as textInput. and then $emit to v-model from selected
            // if user changes selected, set textInput same as selected. and then $emit to v-model from selected
            from: {
                actualDate: '', // YYYY-MM-DD // always equal to v-modal value but form of YYYY-MM-DD
                textInput:'', // only Numbers. YMD order depends on inputType // text-field value
                selected: '', // YYYY-MM-DD // calendar selected value. equal to textInput but form of YYYY-MM-DD
                time: {
                    selected: (this.timepickerMode === 'stepper' ? '01:00:00' : '12:00:00') + (this.containMrdm ? ' AM' : ''),
                    actual: '',
                    value: this.init === 'none' ? '' : (this.timepickerMode === 'stepper' ? '01:00:00' : '12:00:00') + (this.containMrdm ? ' AM' : ''),
                    meridiem: 'AM',
                },
            },
            to: {
                actualDate: '', // YYYY-MM-DD // always equal to v-modal value but form of YYYY-MM-DD
                textInput: '', // only Numbers. YMD order depends on inputType // text-field value
                selected: '', // YYYY-MM-DD // calendar selected value. equal to textInput but form of YYYY-MM-DD
                time: {
                    selected: (this.timepickerMode === 'stepper' ? '01:00:00' : '12:00:00') + (this.containMrdm ? ' AM' : ''),
                    actual: '',
                    value: this.init === 'none' ? '' : (this.timepickerMode === 'stepper' ? '01:00:00' : '12:00:00') + (this.containMrdm ? ' AM' : ''),
                    meridiem: 'AM',
                },
            },
            concatTextInput: '',

            hoverDate: '', // YYYY-MM-DD
            calendarMonth: [], // [YYYY, MM]
            showFlag: 0, // 0: none, 1: single calendar, 2: double calendar

            presetName: '',
            presetVal: '', // YYYY-MM-DD or [YYYY-MM-DD, YYYY-MM-DD]

            /* [FROM VALIDATOR] */
            // hasError
            // errorMessage
            // showValid
            // shake
            /********************/
            validateFlag:false
        }},
        mounted(){
            window.addEventListener('resize', this.resize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resize);
        },
        computed: {
            /* [FROM VALIDATOR] */
            // isValidatable
            // el
            validateTarget() {return this.value;}, // validation setting
            /********************/

            $_class(){
                let rtn =['ur-date-picker--'+this.$_size];
                if(this.preset){
                    rtn.push('ur-date-picker--presetable')
                }
                return  rtn;
            },

            $_size() {
                if((this.size && this.small) || (this.size && this.medium)){
                    console.warn("Props related size are duplicated.")
                }
                switch(this.size){
                    case 'small':   return 'small';
                    case 'medium' : return 'medium';
                }


                if(this.size ==='medium' || this.medium || this.md) {return 'medium'}
                if(this.size ==='small' || this.small || this.sm) {return 'small'}
                if(this.urInput) {return this.urInput.size}
                return this.default.size;
            },
            $_isEmptyAll() {
                return !this.from.selected && !this.to.selected;
            },
            $_fromText() {
                return this.from.textInput;
            },
            $_toText() {
                return this.to.textInput;
            },
            $_concatInputMask() {
                return this.inputType.replace(/#/g,'%#').replace(/[ymd]/gi,'#') + ' ##:##:##' + (this.containMrdm ? ' AA' : '')
                    + ' ~ '
                    + this.inputType.replace(/#/g,'%#').replace(/[ymd]/gi,'#') + ' ##:##:##' + (this.containMrdm ? ' AA' : '') ;
            },
            calendarClass() {
                return {
                    // 'ur-date-picker__calendar--range': this.showFlag === 2,
                    'ur-date-picker__calendar--select-range': this.showFlag === 2 && (this.from.selected || this.to.selected)
                }
            },
            sundayIdx() {
                for(let idx in this.weekDay) {
                    if(this.weekDay[idx].value ==='SUN') {
                        return parseInt(idx);
                    }
                }
                return -1;
            },
            saturdayIdx() {
                for(let idx in this.weekDay) {
                    if(this.weekDay[idx].value ==='SAT') {
                        return parseInt(idx);
                    }
                }
                return -1;
            },
            timepickerClass() {
                let rtn = [];
                rtn.push('ur-date-time-range-picker__time-picker');
                if(!this.containMrdm) {
                    rtn.push('ur-date-time-range-picker__time-picker--no-meridiem');
                }
                return rtn;
            },
            rawInputType() {
                return this.inputType.replace(/[^ymd]/gi, '');
            },

            // for validatorMixin
            messageShow() {
                if(this.hasError === undefined) {
                    return this.guideMessage;
                }
                if(this.hasError === true) {
                    return this.errorMessage;
                }
                if(this.hasError === false) {
                    return this.successMessage || this.guideMessage;
                }
                return undefined;
            },
            wrapperClass() { return {
                'ur-validator--error': this.hasError === true,
                'ur-validator--valid': this.showValid && this.hasError === false,
                'ur-validator--shake': this.shake
            }},
            messageClass() {
                return ['ur-date-picker__message--'+this.messageStyle];
            },
            iconWrapperClass() {
                return {
                    'ur-date-picker__icon-wrapper-disabled' : this.disabled,
                }
            }
        },
        watch: {
            // for validatorMixin
            successMessage: {
                immediate: true,
                handler(val) {
                    this.showValid = !!val;
                }
            },
            //for one input mode
            $_fromText: {
                handler(value) {
                    this.concatTextInput = value + this.to.textInput;
                }
            },
            $_toText: {
                handler(value) {
                    this.concatTextInput = this.from.textInput + value;
                }
            },

            value: {
                immediate: true,
                handler(value){
                    // from.actualDate & to.actualDate only controlled by this handler. they must be equal to v-model
                    if(!this.today) {
                        this.currTime = new Date();
                        this.today = this.dateToYmd(this.currTime);
                    }
                    let rtn, targetMonth, validVal;
                    validVal = this.toValidRange(value);
                    if( this.from.actualDate !== validVal[0] ){
                        this.from.actualDate = validVal[0];
                        this.from.textInput = this.ymdToInput(this.from.actualDate, 'from');
                        this.from.selected = validVal[0];
                    }
                    if( this.to.actualDate !== validVal[1] ) {
                        this.to.actualDate = validVal[1];
                        this.to.textInput = this.ymdToInput(this.to.actualDate, 'to');
                        this.to.selected = validVal[1];
                    }

                    if(validVal[1]) {
                        targetMonth = validVal[1].split('-');
                        targetMonth[1] = parseInt(targetMonth[1]) - 1;
                    } else if(validVal[0]) {
                        targetMonth = validVal[0].split('-');
                    }

                    if(!this.isEqualArray(this.presetVal,validVal)) this.presetName = '';
                    rtn = [this.ymdToModel(validVal[0], 'from'),this.ymdToModel(validVal[1], 'to')];
                    if(!this.isEqualArray(value,rtn)) {
                        // ~documentation~
                        // $ver: v0.1.2
                        // $arg: updated v-model value
                        // v-model을 업데이트하기 위한 이벤트
                        // #Event to update v-model
                        this.$emit('input',rtn);
                    }
                    else if(this.validateFlag) {this.validateFlag=false;this.validateOnEvent();}

                    if(!targetMonth) {
                        let date = this.today;
                        if(date < this.minDate) {date = this.minDate;}
                        if(date > this.maxDate) {date = this.maxDate;}
                        targetMonth = date.split('-');
                    }
                    this.setCalendarMonth([parseInt(targetMonth[0]), parseInt(targetMonth[1])]);
                }
            },
            showFlag(newFlag,oldFlag) {
                let tmp,tmp2;
                // 1. Open & Close
                if(newFlag){this.$refs.floating.open(); this.$emit('toggle-floating', true);}
                else       {this.$refs.floating.close(); this.$emit('toggle-floating', false);}
                // 2. Calculation something
                if(newFlag === 1) {
                    // this.to.textInput = '';
                    // this.to.selected = '';

                    if(this.from.selected) {
                        tmp = this.from.selected;
                    } else {
                        tmp = this.today < this.minDate? this.minDate : this.today > this.maxDate? this.maxDate : this.today;
                    }
                    tmp = tmp.split('-');
                    this.setCalendarMonth([parseInt(tmp[0]),parseInt(tmp[1])]);
                } else if(newFlag === 2) {
                    if(this.to.selected){
                        tmp = this.dateToYmd(this.ymdToDate(this.to.selected,0,-1,0));
                    } else if(this.from.selected) {
                        tmp = this.from.selected;
                    } else {
                        tmp = this.today < this.minDate? this.minDate : this.today > this.maxDate? this.maxDate : this.today;
                    }
                    tmp = tmp.split('-');
                    this.setCalendarMonth([parseInt(tmp[0]),parseInt(tmp[1])]);
                }
            }
        },
        created() {
            this.currTime = new Date();
            this.today = this.dateToYmd(this.currTime);
            this.onClickSegment(this.init);
            if(!Array.isArray(this.calendarMonth) || this.calendarMonth.length !==2 || this.isEqualArray(['',''],this.calendarMonth)) {
                let date = this.today < this.minDate? this.minDate : this.today > this.maxDate? this.maxDate : this.today;
                let tmp = this.dateToYmd(this.ymdToDate(date,0,0,0));
                tmp = tmp.split('-');
                this.setCalendarMonth([parseInt(tmp[0]),parseInt(tmp[1])]);
            }
        },
        methods: {
            /* [FROM VALIDATOR] */
            // validate()        --+
            // isValid()         --+-- exposed methods for manual validate control
            // clearValidation() --+
            // validateOnEvent() -> should be set by each component which uses urValidatorMixin
            /********************/

            toValidRange(value) {
                let newVal;
                if(!(Array.isArray(value) && value.length === 2)) {
                    return ['',''];
                }
                newVal = [this.modelToYmd(value[0]), this.modelToYmd(value[1])];
                if(this.strictRange && !(newVal[0]&&newVal[1])) {
                    return ['',''];
                }
                newVal[0] = this.toValidYmd(newVal[0]);
                newVal[1] = this.toValidYmd(newVal[1]);

                //시간 비교
                let timeReversal, fromTime, toTime, fromMeridiem, toMeridiem;

                fromTime = value[0].substr(this.inputType.length + 1);
                toTime = value[1].substr(this.inputType.length + 1);
                if(fromTime.length > 8) { //ampm
                    fromTime = fromTime.split(' ')[0];
                    toTime = toTime.split(' ')[0];
                    fromMeridiem = fromTime.split(' ')[1];
                    toMeridiem = toTime.split(' ')[1];
                    timeReversal = fromMeridiem > toMeridiem || fromMeridiem === toMeridiem && fromTime > toTime;
                } else {
                    timeReversal = fromTime > toTime;
                }

                // 앞 날짜가 더 빠르거나 날짜가 같은데 시간이 더 빠를 경우
                if(newVal[0] && newVal[1] && newVal[0] > newVal[1]) {
                    newVal[1] = newVal[0];
                    //text input도 맞추기
                    this.to.textInput = this.from.textInput.substr(0,this.rawInputType.length) + this.to.textInput.substr(this.rawInputType.length);
                }
                if( newVal[0] && newVal[1] && newVal[0] === newVal[1] && timeReversal) {
                    this.to.time.selected = this.from.time.selected;
                    this.to.textInput = this.from.textInput;
                }
                return newVal;
            },
            toValidYmd(ymdhis) {
                if(!ymdhis || typeof ymdhis !== 'string') {return '';}
                let ymd = ymdhis.substr(0, this.inputType.length);
                if(ymd > this.maxDate) {ymd = this.maxDate;}
                if(ymd < this.minDate) {ymd = this.minDate;}
                return ymd;
            },
            toValidTime(his) {
                if(!his || typeof his !== 'string') {return '';}
                if(his.length < (this.containMrdm ? 8 : 6)) { return '';}
                let hour, min, sec, mrdm;
                hour = his.substr(0, 2) * 1;
                min = his.substr(2, 2) * 1;
                sec = his.substr(4, 2) * 1;
                mrdm = his.substr(6, 2);
                if((this.containMrdm ? hour > 12 || hour < 1 : hour > 23 || hour < 0)
                    || min > 59 || min < 0 || min % (this.timepickerMode === 'stepper' ? 1 : this.term) !== 0
                    || sec > 59 || sec < 0
                    || (this.containMrdm && !(mrdm === 'AM' || mrdm === 'PM'))) {
                    return ''
                }
                return his;
            },
            $_parseInt(val) {
                let tmp = parseInt(val);
                if(Number.isNaN(tmp)) {return undefined;}
                return tmp;
            },
            setCalendarMonth(calendarMonth) {
                let YYYY,MM;
                if(Array.isArray(calendarMonth) && calendarMonth.length ===2) {
                    this.calendarMonth = [];
                    YYYY = parseInt(calendarMonth[0]);
                    MM = parseInt(calendarMonth[1]);
                    if(MM < 1) {
                        YYYY -= 1;
                        MM += 12;
                    }
                    if(MM > 12) {
                        YYYY += 1;
                        MM -= 12;
                    }
                    this.calendarMonth.push(YYYY);
                    this.calendarMonth.push(MM);
                }
            },
            isEqualArray(arr1,arr2) {
                if(!(Array.isArray(arr1) && Array.isArray(arr2))) {return false;}
                if(arr1.length !== arr2.length){return false;}
                for(let i = 0 ; i < arr1.length ; i++) {
                    if(!this.isEqualModel(arr1[i],arr2[i])) {return false;}
                }
                return true;
            },
            isEqualModel(m1, m2) {
                if(m1 instanceof Date && m2 instanceof Date) {
                    if(m1.getFullYear() === m2.getFullYear() && m1.getMonth() === m2.getMonth() && m1.getDate() === m2.getDate() ) {
                        return true;
                    }
                }
                if(Array.isArray(m1) && Array.isArray(m2)) {return this.isEqualArray(m1,m2);}
                return m1 === m2;
            },

            /*
            ~  CONVERTERS
            ~  'ymd': fixed format that used on default date format in this component 'YYYY-MM-DD'
            ~  'input': string used in text-field. only have Numbers.
            ~  'model': Date or Array or some formatted string which is set as props.modelType.
            ~           It is used as type of v-model in single date-picker.
            ~           In case of using range or strictRange, v-model will be [modelType, modelType]
            ~
            ~  inputToYmd(input)
            ~  ymdToInput(ymd)
            ~  textToYmd(text, textFormat)
            ~  ymdToText(ymd, textFormat)
            ~  changeTextFormat(text, fromFormat, toFormat)
            ~  ymdToModel(ymd)
            ~  ModelToYmd(model)
            ~  dateToYmd(date)
            ~  ymdToDate(ymd, dy, dm, dd): dy, dm, dd is difference of year, month, date. default is 0.
            ~                              eg.) ymdToDate('1991-02-04', 1, -1, 3) => new Date(1992, 0, 7) [*2nd arg 0 is Jan.]
            */

            // @vuese
            // $ver: v0.1.2
            // $arg: target data to convert
            // $arg: target data's format string (eg. YYYY-MM-DD)
            // $arg: return data's format string (eg. DD/MM/YYYY)
            // $return: converted data
            // <em>arg1</em>의 format을 가진 <em>arg0</em>값을 <em>arg2</em>의 format에 맞게 변환하여 반환합니다.
            // #Converts <em>arg0</em> with the format of <em>arg1</em> to match the format of <em>arg2</em> and returns.
            changeTextFormat(data, fromFormat, toFormat) {
                if(fromFormat === toFormat) {
                    return data;
                }
                let tmp = this.textToYmd(data, fromFormat);
                return this.ymdToText(tmp, toFormat);
            },
            inputToYmd(dateTimeInput){
                if(!dateTimeInput || typeof(dateTimeInput) !== 'string') {return '';}
                let inputFormat = this.inputType.replace(/[^ymd]/gi,'').toUpperCase();
                let sIdx = inputFormat.indexOf('Y');
                let y4Flag = inputFormat.indexOf('YYYY') !== -1;
                let YYYY, tmp;
                let input = dateTimeInput.substr(0, this.inputType.replace(/[^ymd]/gi, '').length);
                if(input.length === 4) {
                    // no YYYY or YY
                    YYYY = this.today.split('-')[0];
                    if(y4Flag) {
                        tmp = input.slice(0,sIdx) + YYYY + input.slice(sIdx);
                    } else {
                        tmp = input.slice(0,sIdx) + YYYY.slice(2) + input.slice(sIdx);
                    }
                } else if(input.length === 6) {
                    // YY
                    if(y4Flag) {
                        YYYY = input.slice(sIdx,sIdx+2);
                        YYYY = parseInt(YYYY)<70?'20'+YYYY:'19'+YYYY;
                        tmp = input.slice(0,sIdx) + YYYY + input.slice(sIdx+2);
                    } else {
                        tmp = input;
                    }
                } else if(input.length === 8) {
                    // YYYY
                    if(y4Flag) {
                        tmp = input;
                    } else {
                        YYYY = input.slice(sIdx, sIdx+4);
                        tmp = input.slice(0,sIdx) + YYYY.slice(2) + input.slice(sIdx+4);
                    }
                } else {
                    return '';
                }
                return this.textToYmd(tmp, inputFormat);
            },
            ymdToInput(ymd, fromTo) {
                return this.ymdToText(ymd, this.inputType.replace(/[^ymd]/gi,''), fromTo);
            },
            textToYmd(text, format) {
                // "Formatted text" ---{'textFormat'}---> 'YYYY-MM-DD' text
                // 4/1 로직 재구축
                // 0. precheck
                if(!text || !format) return null;
                let dateText = text.split(' ')[0];
                if(dateText.length !== format.length) return null;
                var _fmt = format.toUpperCase();
                var iy, im, id, y, m, d,
                    today = new Date(), rtn;
                // 1. get Year
                if( (iy = _fmt.indexOf('YYYY')) >= 0) {
                    y = parseInt(text.substr(iy,4));
                } else if((iy = _fmt.indexOf('YY')) >= 0){
                    y = parseInt(text.substr(iy,2));
                    if(y<70) y+= 2000;
                    else y+= 1900;
                } else {
                    y = today.getFullYear();
                }
                // 2. get Month
                if( (im = _fmt.indexOf('MM')) >= 0) {
                    m = parseInt(text.substr(im,2))-1;
                } else {
                    m = today.getMonth();
                }
                // 2.x min/max adjust
                if(m<0) m=0;
                if(m>11) m=11;
                // TODO How about 'M'
                // TODO How about 'MMM'
                // 3. get Day
                if( (id = _fmt.indexOf('DD')) >= 0) {
                    d = parseInt(text.substr(id,2));
                } else {
                    d = today.getDate();
                }
                // 3.x min/max adjust
                if(d<1) {d=1}
                const DAY_OF_MONTH = [31,28,31,30,31,30,31,31,30,31,30,31];
                const isLeaf = (y) => y%400?(y%100?(y%4?0:1):0):1;
                var maxD = DAY_OF_MONTH[m] + (m===1?isLeaf(y):0);
                if(d>maxD) { d = maxD; }
                // TODO How about 'D'
                // x. make date
                rtn = ("000"+y).slice(-4) + '-' +
                    ("0"+(m+1)).slice(-2) + '-' +
                    ("0"+d).slice(-2);
                return /^(19[7-9][0-9]|[2-9][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(rtn)?rtn:'';
            },
            /*NOSONAR*/ymdToText(val, textFormat, fromTo) {
                let tmp, rtn;
                // valid val?
                if(!val || typeof(val) !== 'string') {return '';}
                tmp = val.split('-');
                if(tmp.length !== 3) {return '';}
                // valid textFormat?
                if(!/^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(textFormat)
                    || textFormat.match(/y{1,4}/gi).length !== 1
                    || textFormat.match(/m{1,2}/gi).length !== 1
                    || textFormat.match(/d{1,2}/gi).length !== 1) {
                    console.error('[UR-DATE-PICKER] invalid text format is given: '+textFormat);
                    return '';
                }
                rtn = textFormat.toUpperCase();
                rtn = rtn.replace('YYYY',tmp[0]);
                rtn = rtn.replace('YY', tmp[0].slice(2));
                rtn = rtn.replace('MM', tmp[1]);
                rtn = rtn.replace('DD', tmp[2]);

                let isRawFormat = textFormat.match(/[^ymd]/gi) === null;
                let timeValue, timeText;
                if(fromTo){
                    // fromTo가 넘어왔다면 이것은 시간 선택 으로 showflag 체크
                    timeValue = fromTo === 'from' ? this.from.time : this.to.time;
                } else {
                    // 하나라도 비었다면 날짜 선택
                    timeValue = this.$_isEmptyAll? this.from.time : this.to.time;
                }
                let input = fromTo === 'from' ? this.from : this.to;
                if(isRawFormat){
                    if(timeValue.value === timeValue.selected){
                        if(timeValue.value.split(':')[0].length === 1){
                            timeText = '0' + timeValue.value.replace(/[: ]/gi, '');
                        } else {
                            timeText = timeValue.value.replace(/[: ]/gi, '');
                        }
                    } else {
                        if(timeValue.selected.split(':')[0].length === 1){
                            timeText = '0' + timeValue.selected.replace(/[: ]/gi, '');
                        } else {
                            timeText = timeValue.selected.replace(/[: ]/gi, '');
                        }
                    }
                    //fixme 초 다르면 input의 초를 넣어준다 -- 아아아아주 난잡하다  - timepicker가 초를 관리 안 하기 때문에
                    let inputSec = input.textInput.substr(this.rawInputType.length + 4, 2);
                    if(inputSec !== '' && inputSec.length === 2 && timeText.substr(4,2) !== inputSec) {
                        timeText = timeText.substr(0,4) + inputSec + timeText.substr(6);
                    }
                } else {
                    if(timeValue.value === timeValue.selected){
                        if(timeValue.value.split(':')[0].length === 1){
                            timeText = ' 0' + timeValue.value;
                        } else {
                            timeText = ' ' + timeValue.value;
                        }
                    } else {
                        if(timeValue.selected.split(':')[0].length === 1){
                            timeText = ' 0' + timeValue.selected;
                        } else {
                            timeText = ' ' + timeValue.selected;
                        }
                    }
                    //fixme 초 다르면 input의 초를 넣어준다 -- 아아아아주 난잡하다  - timepicker가 초를 관리 안 하기 때문에
                    let inputSec = input.textInput.substr(this.rawInputType.length + 4, 2);
                    if(inputSec !== '' && inputSec.length === 2 && timeText.substr(7,2) !== inputSec) {
                        timeText = timeText.substr(0,7) + inputSec + timeText.substr(9);
                    }
                }

                rtn = rtn + timeText;
                return rtn;
            },
            // @vuese
            // $ver: v0.1.2
            // $arg: target data to convert (format is YYYY-MM-DD)
            // $return: converted data
            // 입력값을 <em>ur-date-picker</em>에 설정된 model-type에 맞게 변환합니다.
            // 입력값은 YYYY-MM-DD의 format으로 주어져야 합니다.
            // #Convert the input to match the model-type set in the <em>ur-date-picker</em>.
            // #Input must be given in the format of YYYY-MM-DD.
            /*NOSONAR*/ymdToModel(val, fromTo) {
                // from YYYY-MM-DD to v-model value
                let tmp, rtn, dateTmp, timeTmp;
                if(!val || typeof(val) !== 'string') {return '';}
                // tmp = val.split(' ');
                tmp = val.split('-');
                if(tmp.length !== 3) {return '';}
                if(/^date$/i.test(this.modelType)) {
                    return new Date(parseInt(tmp[0]), parseInt(tmp[1])-1);
                }
                if(/^array$/i.test(this.modelType)) {
                    return val.split('-');
                }
                return this.ymdToText(val, this.modelType, fromTo);
            },
            // @vuese
            // $ver: v0.1.2
            // $arg: target data to convert (format is same as model-type)
            // $return: converted data (YYYY-MM-DD)
            // 입력값을 YYYY-MM-DD format의 문자열로 변환하여 반환합니다.
            // 입력값은 <em>ur-date-picker</em>의 model-type과 같은 형식으로 주어져야합니다.
            // #Convert the input to a string in YYYY-MM-DD format and return it.
            // #The input should be given in the same format as the model-type of the <em>ur-date-picker</em>.
            modelToYmd(val) {
                // from v-model value to YYYY-MM-DD
                let rtn;
                if(/^date$/i.test(this.modelType)) {
                    if(!val || typeof (val) !== 'string') {return '';}
                    // model type = date object
                    return this.dateToYmd(val);
                }
                if(/^array$/i.test(this.modelType)) {
                    // model type = array [YYYY,MM,DD]
                    if( !( Array.isArray(val) && val.length === 3 ) ) {return '';}
                    rtn = [];
                    // year
                    let ymd = parseInt(val[0]);
                    if(isNaN(ymd)) {return '';}
                    if(ymd < 70) {
                        rtn.push('20'+ymd);
                    } else if (ymd < 100) {
                        rtn.push('19'+ymd);
                    } else if (ymd < 1970 || ymd > 9999) {
                        return '';
                    }
                    // month
                    ymd = parseInt(val[1]);
                    if(isNaN(ymd) || ymd<=0 || ymd>12) {return '';}
                    if(ymd<10) {rtn.push('0'+ymd);}
                    else {rtn.push(''+ymd);}
                    // date
                    ymd = parseInt(val[2]);
                    if(isNaN(ymd) || ymd<=0 || ymd>31) {return '';}
                    if(ymd<10) {rtn.push('0'+ymd);}
                    else {rtn.push(''+ymd);}

                    rtn = rtn.join('-');
                    return /^(19[7-9][0-9]|[2-9][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(rtn)?rtn:'';
                }
                return this.textToYmd(val,this.modelType);
            },
            // @vuese
            // $ver: v0.1.2
            // $arg: target data to convert (javascript Date object)
            // $return: converted data (YYYY-MM-DD)
            // javascript Date object를 입력값으로 주면 YYYY-MM-DD 형식의 문자열로 변환하여 반환합니다.
            // #If a javascript Date object is given as input, it is converted to a string in YYYY-MM-DD format and returned.
            dateToYmd(date) {
                if(!(date instanceof Date)) {return '';}
                let YYYY = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? '0'+MM:MM;
                let DD = date.getDate();
                DD = DD < 10 ? '0'+DD:DD;
                return [YYYY,MM,DD].join('-');
            },
            ymdToDate(ymd,dy=0,dm=0,dd=0) {
                let tmp = ymd.split('-');
                return new Date(parseInt(tmp[0]) + dy,parseInt(tmp[1]) - 1 + dm,parseInt(tmp[2]) + dd);
            },
            /*
            * EVENT HANDLERS
            * */
            onClickSegment(str) {
                this.onClickOutside();
                this.presetName = str;
                let tmp, dy=0,dm=0,dd=0;
                switch(str) {
                    case 'today':
                        this.presetVal = [this.today, this.today];
                        tmp = [this.ymdToModel(this.presetVal[0]), this.ymdToModel((this.presetVal[1]))];
                        if (!this.isEqualArray(this.value, tmp)) this.$emit('input', tmp);
                        return;
                    case 'clear':
                        this.presetVal = ['', ''];
                        this.$emit('input', ['', '']);
                        return;
                    case 'none':
                        this.from.time.value = this.value[0].split(" ")[1];
                        this.to.time.value = this.value[1].split(" ")[1];
                        let defaultTime = (this.timepickerMode === 'stepper' ? '01:00:00' : '12:00:00') + (this.containMrdm ? ' AM' : '');
                        if(this.isValidTimePattern(this.value[0].split(" ")[1])){
                            this.from.time.selected = this.value[0].split(" ")[1];
                        } else {
                            this.from.time.selected = defaultTime;
                        }
                        if(this.isValidTimePattern(this.value[1].split(" ")[1])){
                            this.to.time.selected = this.value[1].split(" ")[1];
                        } else {
                            this.to.time.selected = defaultTime;
                        }
                        return;
                    default:
                        break;
                }
                if (!/^(day|week|month|year)[+-][0-9]+$/.test(str)) {
                    // else = 'none' : do nothing
                    return;
                }
                tmp = str.split(/(?=[+-])/);
                switch (tmp[0]) {
                    case 'day':
                        dd = parseInt(tmp[1]);
                        break;
                    case 'week':
                        dd = parseInt(tmp[1]) * 7;
                        break;
                    case 'month':
                        dm = parseInt(tmp[1]);
                        break;
                    case 'year':
                        dy = parseInt(tmp[1]);
                        break;
                }
                if (parseInt(tmp[1]) > 0) {
                    this.presetVal = [this.today, this.dateToYmd(this.ymdToDate(this.today, dy, dm, dd))];
                } else {
                    this.presetVal = [this.dateToYmd(this.ymdToDate(this.today, dy, dm, dd)), this.today];
                }
                tmp = [this.ymdToModel(this.presetVal[0]), this.ymdToModel((this.presetVal[1]))];
                if (!this.isEqualArray(this.value, tmp)) this.$emit('input', tmp);

            },
            onFocus(idx) {
                if(idx === 2 && this.strictRange && !this.from.selected) {
                    this.$refs['from-text'].focus();return;
                }
                this.showFlag = idx;
            },
            onFocusTimePicker(idx) {
                this.showFlag = idx;
            },
            onClickIcon(idx) {
                if(this.disabled) {
                    return;
                }
                if(this.showFlag !== 0) {
                    this.onClickOutside();
                    return;
                }
                this.showFlag = this.showFlag === idx ? 0 : idx;
            },
            onUpdateConcat(tabEvent = DUMMY_EVENT) {
                let from, to, inputTypeLength;
                inputTypeLength = this.rawInputType.length  + (this.containMrdm ? 8 : 6);
                from = this.concatTextInput.substr(0, inputTypeLength);
                to = this.concatTextInput.substr(inputTypeLength, inputTypeLength);
                this.from.textInput = from;
                this.to.textInput = to;
                // enter냐 keydown.tab이냐 구분
                if(typeof tabEvent ==='string'){
                    this.onUpdate(1);
                    this.onUpdate(2);
                } else {
                    this.onUpdate(1, tabEvent);
                    this.onUpdate(2, tabEvent);
                }
            },
            /*NOSONAR*/onUpdate(idx, tabEvent = DUMMY_EVENT) {
                if(tabEvent.shiftKey) {this.showFlag=0;return;}
                // textInput is updated
                let tmp, rtn = ['', ''], newValue, newTime;
                if(idx === 1) {
                    // range date picker && on update 'from' text
                    newValue = this.inputToYmd(this.from.textInput);
                    newValue = this.toValidYmd(newValue);
                    newTime = this.from.textInput.substr(this.rawInputType.length, 8);
                    newTime = this.toValidTime(newTime);
                    if (newValue !== '' && newTime !== '') {
                        newTime = newTime.substr(0, 2) + ':' + newTime.substr(2, 2) + ':' + newTime.substr(4, 2)
                            + (this.containMrdm ?' ' + newTime.substr(6, 2) : '');
                        this.from.time.selected = newTime;
                        // proper input received
                        this.from.textInput = this.ymdToInput(newValue, 'from');
                        this.from.selected = newValue;
                        tmp = this.from.selected.split('-');
                        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
                        if (!!this.$refs['to-text'] && !(tabEvent instanceof WheelEvent)) { // oneInputMode v-if 로 안 그려지는 경우 대비
                            this.$refs['to-text'].focus();
                        }
                        tabEvent.preventDefault();
                        return;
                    }
                    if (this.from.textInput) {
                        // intend to input some date text but not valid -> restore text same as actualDate
                        this.from.textInput = this.ymdToInput(this.from.actualDate, 'from');
                        tabEvent.preventDefault();
                        return;
                    }
                    if (!this.strictRange) {
                        // empty input but want to enter 'to' date first. (only when strictRange false)
                        // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
                        this.from.selected = '';
                        if (!!this.$refs['to-text'] && !(tabEvent instanceof WheelEvent)) { // oneInputMode v-if 로 안 그려지는 경우 대비
                            this.$refs['to-text'].focus();
                        }
                        tabEvent.preventDefault();
                        return;
                    }
                    // strictRange true
                    if (!this.isEqualArray(rtn, [this.from.selected, this.to.selected])) {
                        // when strictRange true, empty input make selected date clear.
                        this.from.selected = '';
                        this.to.selected = '';
                        tabEvent.preventDefault();
                        return;
                    }
                    // already clear, update v-model & close calendar
                    this.onConfirm();
                    return; // not execute e.preventDefault
                }

                // idx = 2
                // range date picker && on update 'to' text
                newValue = this.inputToYmd(this.to.textInput);
                newValue = this.toValidYmd(newValue);
                newTime = this.to.textInput.substr(this.rawInputType.length, 8);
                newTime = this.toValidTime(newTime);
                if(newValue !== '' && newTime !== '' && this.strictRange) {
                    // proper input received & strictRange true
                    if (!this.from.selected) {
                        // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
                        if (!!this.$refs['from-text'] && !(tabEvent instanceof WheelEvent)) { // oneInputMode v-if 로 안 그려지는 경우 대비
                            this.$refs['from-text'].focus();
                        }
                        tabEvent.preventDefault();return;
                    }
                    if (this.from.selected > newValue) {
                        newTime = newTime.substr(0, 2) + ':' + newTime.substr(2, 2) + ':' + newTime.substr(4, 2)
                            + (this.containMrdm ?' ' + newTime.substr(6, 2) : '');
                        this.to.time.selected = newTime;

                        // 'to' date input is earlier than 'from' date -> update 'from' date as received input.
                        this.from.textInput = this.ymdToInput(newValue, 'to');
                        this.from.selected = newValue;
                        tmp = this.from.selected.split('-');

                        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
                        this.to.textInput = '';
                        this.to.selected = '';
                        tabEvent.preventDefault();
                        //todo 엔터 한방에 값 입력 하게 해달라는 cello의 요청 - 다른 picker들도 적용해야할지?
                        this.onConfirm();
                        return;
                    }
                    if (newValue !== this.to.selected) {
                        // update selected 'to' date as received input.
                        this.to.textInput = this.ymdToInput(newValue, 'to');
                        this.to.selected = newValue;
                        tmp = this.to.selected.split('-');

                        if (!this.isEqualArray(this.calendarMonth, [parseInt(tmp[0]), parseInt(tmp[1])])) {
                            tmp = this.dateToYmd(this.ymdToDate(this.to.selected, 0, -1, 0)).split('-');
                            this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
                        }
                        tabEvent.preventDefault();return;
                    }
                    // selected date already updated, update v-model & close calendar
                    this.onConfirm();return; // not execute e.preventDefault
                } else if(newValue !== '' && newValue !== this.to.selected || newTime !== '' && newTime !== this.to.time.selected.replace(/[ :]/g, '')) {
                    newTime = newTime.substr(0, 2) + ':' + newTime.substr(2, 2) + ':' + newTime.substr(4, 2)
                        + (this.containMrdm ?' ' + newTime.substr(6, 2) : '');
                    this.to.time.selected = newTime;

                    // proper input received & strictRange false -> make selected 'to' date as received input
                    this.to.textInput = this.ymdToInput(newValue, 'to');
                    this.to.selected = newValue;
                    tmp = this.to.selected.split('-');
                    if(!this.isEqualArray(this.calendarMonth,[parseInt(tmp[0]),parseInt(tmp[1])])) {
                        tmp = this.dateToYmd(this.ymdToDate(this.to.selected,0,-1,0)).split('-');
                        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
                    }
                    tabEvent.preventDefault();
                    //todo 엔터 한방에 값 입력 하게 해달라는 cello의 요청 - 다른 picker들도 적용해야할지?
                    this.onConfirm();
                    return;
                } else if(newValue !== '' && newTime !== '') {
                    // proper input received & strictRange false & selected 'to' date already updated
                    // -> update v-model & close calendar
                    this.onConfirm();return; // not execute e.preventDefault
                } else if(this.to.textInput) {
                    // intend to input some date text but not valid -> restore text same as actualDate
                    this.to.textInput = this.ymdToInput(this.to.actualDate, 'to');
                    tabEvent.preventDefault();return;
                } else if(this.strictRange || this.to.selected) {
                    // empty input recieved -> clear selected 'to' date
                    this.to.selected = '';
                    tabEvent.preventDefault();return;
                }
                // selected 'to' date already cleared & strictRange is false -> update v-model & close calendar
                this.onConfirm();return; // not execute e.preventDefault
            },
            onClickCancel(){
                this.from.textInput = '';
                this.from.selected = '';
                this.to.textInput = '';
                this.to.selected = '';
            },
            onClickDate(date) {
                if(date.state === 'prev') {
                    this.onClickPrevMonth(this.showFlag);
                } else if (date.state === 'next') {
                    this.onClickNextMonth(this.showFlag);
                }
                // TODO 이게 최선인가?
                switch(this.showFlag) {
                    case 1:
                        //range picker의 왼쪽 입력창 아이콘 클릭시
                        //from -> to 선택
                        if(this.$_isEmptyAll){
                            this.from.textInput = this.ymdToInput(date.value, 'from');
                            this.from.selected = date.value;
                            return ;
                        }
                        if(this.to.selected) {
                            //from,to 모두 선택한 상태에서 날짜 선택하면 모두 취소후 선택한 날짜를 from으로 설정
                            this.onClickCancel();
                            this.from.textInput = this.ymdToInput(date.value, 'from');
                            this.from.selected = date.value;
                        } else if(this.from.selected) {
                            if(date.value < this.from.selected) {
                                // 선택했던 날짜(from)보다 이전 날짜 선택하면 그날을 from 값으로 설정
                                this.from.textInput = this.ymdToInput(date.value, 'from');
                                this.from.selected = date.value;
                            } else {
                                // 선택했던 날짜(from) 이후 날짜를 선택하면 그날을 to 로 설정
                                this.to.textInput = this.ymdToInput(date.value, 'to');
                                this.to.selected = date.value;
                                if(this.autoConfirm){
                                  this.onConfirm();
                                }
                            }
                        } else {
                            //이경우는 뭘까?
                            this.from.textInput = this.ymdToInput(date.value, 'from');
                            this.from.selected = date.value;
                        }
                        break;
                    case 2:
                        //range picker의 오른쪽 입력창 아이콘 클릭시
                        //to->from 선택
                        if(this.$_isEmptyAll){
                            this.to.textInput = this.ymdToInput(date.value, 'to');
                            this.to.selected = date.value;
                            return;
                        }
                        if(this.from.selected) {
                            //to,from 모두 선택한 상태에서 날짜 선택하면 모두 취소후 선택한 날짜를 to로 설정
                            this.onClickCancel();
                            this.to.textInput = this.ymdToInput(date.value, 'to');
                            this.to.selected = date.value;
                        } else if(this.to.selected) {
                            if(this.to.selected < date.value) {
                                // 선택했던 날짜(to)보다 이후 날짜 선택하면 그날을 to 값으로 설정
                                this.to.textInput = this.ymdToInput(date.value, 'to');
                                this.to.selected = date.value;
                            } else {
                                // 선택했던 날짜(to) 이전 날짜를 선택하면 그날을 from 로 설정
                                this.from.textInput = this.ymdToInput(date.value, 'from');
                                this.from.selected = date.value;
                                if(this.autoConfirm){
                                  this.onConfirm();
                                }
                            }
                        }else {
                            // 이경우는 뭘까?
                            this.to.textInput = this.ymdToInput(date.value, 'to');
                            this.to.selected = date.value;
                        }
                        break;
                }
            },
            onConfirm(e) {
                // selected confirmed and want to be update v-model & actual date
                // close calendar
                let rtn;
                this.from.time.value = this.from.time.selected;
                this.to.time.value = this.to.time.selected;
                rtn = [this.ymdToModel(this.from.selected, 'from'), this.ymdToModel(this.to.selected, 'to')];
                if(!this.isEqualArray(this.value,rtn)){
                    this.$emit('input',rtn);
                    this.validateFlag=true;
                }
                else {this.validateOnEvent();}
                this.showFlag = 0;
            },
            onClickPrevMonth(idx) {
                this.setCalendarMonth([parseInt(this.calendarMonth[0]),parseInt(this.calendarMonth[1]) - 1]);
            },
            onClickNextMonth(idx) {
                this.setCalendarMonth([parseInt(this.calendarMonth[0]),parseInt(this.calendarMonth[1]) + 1]);
            },
            onClickOutside(e) {
                // set selected back to original value
                // close calendar
                if(e && e.target.classList.length > 0 && e.target.className.indexOf('ur-dropdown') > -1){
                    //for timepicker dropdown
                    return;
                }
                // auto-confirm 활성화 시 시간값 저장
                if (this.autoConfirm) {
                    this.from.time.value = this.from.time.selected;
                    this.to.time.value = this.to.time.selected;
                } else {
                    let defaultTime = (this.timepickerMode === 'stepper' ? '01:00:00' : '12:00:00') + (this.containMrdm ? ' AM' : '');
                    if(this.isValidTimePattern(this.value[0].split(" ")[1])){
                        this.from.time.selected = this.value[0].split(" ")[1];
                    } else {
                        this.from.time.selected = defaultTime;
                    }
                    if(this.isValidTimePattern(this.value[1].split(" ")[1])){
                        this.to.time.selected = this.value[1].split(" ")[1];
                    } else {
                        this.to.time.selected = defaultTime;
                    }
                }
                let tmp;
                this.from.textInput = this.ymdToInput(this.from.actualDate, 'from');
                this.from.selected = this.from.actualDate;
                this.to.textInput = this.ymdToInput(this.to.actualDate, 'to');
                this.to.selected = this.to.actualDate;
                if(this.to.actualDate) {
                    tmp = this.to.actualDate.split('-');
                    tmp[1] = parseInt(tmp[1]) - 1;
                } else if(this.from.actualDate) {
                    tmp = this.from.actualDate.split('-');
                } else {
                    tmp = this.today.split('-');
                }
                this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
                this.showFlag=0;
                // auto-confirm 활성화 시 바깥 클릭 시 선택한 값을 저장
                if(this.autoConfirm) this.onConfirm();
            },
            onSelectedTime() {
                this.from.textInput = this.ymdToInput(this.from.selected, 'from');
                this.to.textInput = this.ymdToInput(this.to.selected, 'to');
            },
            selectedValueUp(el, fromTo){
                if(el.currentTarget) {
                    let cursorPosition = el.currentTarget.selectionStart;
                    this.selectedValueChange(cursorPosition, 'add', fromTo);
                    this.$nextTick(() => {
                        el.currentTarget.setSelectionRange(cursorPosition, cursorPosition);
                    });
                }

            },
            selectedValueDown(el, fromTo){
                if(el.currentTarget){
                    let cursorPosition = el.currentTarget.selectionEnd;
                    this.selectedValueChange(cursorPosition, 'extract', fromTo);
                    this.$nextTick(() => {
                        el.currentTarget.setSelectionRange(cursorPosition, cursorPosition);
                    });
                }
            },
            mouseWheel(el, fromTo){
                if(!this.wheelEvent) {
                    return;
                }
                this.wheelEvent = false;
                let cursorPosition = el.currentTarget.selectionStart;
                if(el.deltaY > 0) {
                    this.selectedValueChange(cursorPosition, 'extract', fromTo);
                } else if (el.deltaY < 0) {
                    this.selectedValueChange(cursorPosition, 'add', fromTo);
                }
                if(fromTo === 'from'){
                    this.onUpdate(1, el);
                } else {
                    this.onUpdate(2, el);
                }
                this.$nextTick(() => {
                    el.currentTarget.setSelectionRange(cursorPosition, cursorPosition);
                    setTimeout(() => {
                        this.wheelEvent = true;
                    },50);
                });
            },
            /*NOSONAR*/selectedValueChange(cursorPosition, addExtract, fromTo) {
                let input, ymd, time;
                // 포맷 안 맞으면 리턴
                if(fromTo === 'from') {
                    input = this.from;
                } else {
                    input = this.to;
                }
                ymd = this.inputToYmd(input.textInput);
                ymd = this.toValidYmd(ymd);
                time = input.textInput.substr(this.rawInputType.length, 8);
                time = this.toValidTime(time);
                if (ymd === '' || time === '') {
                    return;
                }

                let positionVal = 0, min = 0, max = 0, newPositionVal = 0, dateTime;
                dateTime = fromTo === 'from' ? this.from : this.to;
                if(cursorPosition <= this.inputType.length){
                    let yearPosition, monthPosition, dayPosition, yearLength;
                    if(this.inputType.indexOf('YYYY') > -1) {
                        yearPosition = this.inputType.indexOf('YYYY');
                    } else {
                        yearPosition = this.inputType.indexOf('YY');
                    }
                    monthPosition = this.inputType.indexOf('MM');
                    dayPosition = this.inputType.indexOf('DD');

                    let rawYearPosition = 0, rawMonthPosition = 0, rawDayPosition = 0;
                    if(this.rawInputType.indexOf('YYYY') > -1) {
                        rawYearPosition = this.rawInputType.indexOf('YYYY');
                        yearLength = 4;
                    } else {
                        rawYearPosition = this.rawInputType.indexOf('YY');
                        yearLength = 2;
                    }
                    rawMonthPosition = this.rawInputType.indexOf('MM');
                    rawDayPosition = this.rawInputType.indexOf('DD');

                    if(cursorPosition >= yearPosition && cursorPosition <= yearPosition + yearLength){
                        positionVal = dateTime.textInput.substr(rawYearPosition, yearLength) * 1;
                        min = 1970;
                        max = 9999;
                    } else if(cursorPosition >= monthPosition && cursorPosition <= monthPosition + 2){
                        positionVal = dateTime.textInput.substr(rawMonthPosition, 2) * 1;
                        min = 1;
                        max = 12;
                    } else if(cursorPosition >= dayPosition && cursorPosition <= dayPosition + 2){
                        positionVal = dateTime.textInput.substr(rawDayPosition, 2) * 1;
                        min = 1;
                        const DAY_OF_MONTH = [31,28,31,30,31,30,31,31,30,31,30,31];
                        max = DAY_OF_MONTH[dateTime.textInput.substr(rawMonthPosition, 2) * 1 - 1];
                    }
                    if(addExtract === 'add'){
                        if(positionVal + 1 > max) {
                            newPositionVal = min;
                        } else {
                            newPositionVal = positionVal + 1;
                        }
                    } else {
                        if(positionVal - 1 < min) {
                            newPositionVal = max;
                        } else {
                            newPositionVal = positionVal - 1;
                        }
                    }
                    if(newPositionVal < 10){
                        newPositionVal = '0' + newPositionVal;
                    } else {
                        newPositionVal = '' + newPositionVal;
                    }
                    let index = max === 9999 ? rawYearPosition : max === 12 ? rawMonthPosition : rawDayPosition;
                    dateTime.textInput = dateTime.textInput.substring(0, index) + newPositionVal + dateTime.textInput.substring(index + newPositionVal.length);

                } else if (cursorPosition > this.inputType.length && cursorPosition < this.inputType.length + 10) {
                    let positionType;
                    if(cursorPosition >= 11 && cursorPosition <= 13){
                        positionVal = dateTime.textInput.substr(this.rawInputType.length, 2) * 1;
                        min = 1;
                        max = 12;
                        positionType = 'hour';
                    } else if(cursorPosition >= 14 && cursorPosition <= 16){
                        positionVal = dateTime.textInput.substr(this.rawInputType.length + 2, 2) * 1;
                        max = 59;
                        positionType = 'min';
                    } else if(cursorPosition >= 17 && cursorPosition <= 19){
                        positionVal = dateTime.textInput.substr(this.rawInputType.length + 4, 2) * 1;
                        max = 59;
                        positionType = 'sec';
                    }
                    let term = positionType !== 'min' || this.timepickerMode === 'stepper' ? 1 : this.term;
                    if(addExtract === 'add'){
                        if(positionVal + term > max) {
                            newPositionVal = min;
                        } else {
                            newPositionVal = positionVal + term;
                        }
                    } else {
                        if(positionVal - term < min) {
                            newPositionVal = max === 12 ? max : max + 1 - term;
                        } else {
                            newPositionVal = positionVal - term;
                        }
                    }
                    if(newPositionVal < 10){
                        newPositionVal = '0' + newPositionVal;
                    } else {
                        //string으로 변환
                        newPositionVal = '' + newPositionVal;
                    }
                    let index = positionType === 'hour' ? this.rawInputType.length : (positionType === 'min' ? this.rawInputType.length + 2 : this.rawInputType.length + 4);
                    dateTime.textInput = dateTime.textInput.substring(0, index) + newPositionVal + dateTime.textInput.substring(index + newPositionVal.length);

                } else if(this.containMrdm) {
                    if(dateTime.textInput.indexOf('AM') > -1){
                        dateTime.textInput = dateTime.textInput.substring(0, this.rawInputType.length + 6) + 'PM';
                    } else {
                        dateTime.textInput = dateTime.textInput.substring(0, this.rawInputType.length + 6) + 'AM';
                    }
                }
            },

            /*
            * ACT LIKE COMPUTED but need some argument from template side
            * */
            monthFilter(month,flag) {
                let m = parseInt(month[1])-2+flag;
                let y = parseInt(month[0]);
                if(m < 0 ) {
                    m = m + 12;
                    y = y - 1;
                } else if (m>11) {
                    m = m - 12;
                    y = y + 1;
                }
                m = m < 0 ? m+12 : m > 11 ? m-12 : m;
                return this.monthAbbr[m] + ' ' + y;
            },
            makePrevDate(calendarMonth, flag) {
                let arr = [];
                // prev month's last few days
                let selMon = new Date(calendarMonth[0],calendarMonth[1]-2+flag);
                let idx = selMon.getDay();
                for(let i = 1 - idx;i < 1;i++) {
                    let tmp = new Date(calendarMonth[0],calendarMonth[1]-2+flag,i);
                    let value = this.dateToYmd(tmp);
                    let state = 'prev',rangeColor=[];
                    if(value < this.minDate) {state = 'disabled';}
                    if(this.maxDate < value) {state = 'disabled';}
                    if(flag ===2) {
                        state = 'invisible';
                    } else {
                        rangeColor = this.makeRangeColor(value,this.from.selected, this.to.selected, this.hoverDate);
                    }

                    arr.push({
                        text: tmp.getDate(),
                        value: value,
                        state: state,
                        rangeColor:rangeColor
                    });
                }
                return [arr, idx];
            },
            makeCurrDate(calendarMonth, flag, arr, idx) {
                let rtn = [] ;
                // curr month's full days
                let tmp = this.dateToYmd(new Date(calendarMonth[0],calendarMonth[1]-2+flag)).slice(0,8);
                let maxDate = (new Date(calendarMonth[0],calendarMonth[1]-1+flag) - new Date(calendarMonth[0],calendarMonth[1]-2+flag)) / 24 / 60 / 60 / 1000;
                for(let i = 1; i <= maxDate; i++) {
                    let value = tmp + (i<10?'0'+i:i);
                    let state = false,rangeColor=[];
                    if(value < this.minDate) {state = 'disabled';}
                    if(this.maxDate < value) {state = 'disabled';}
                    rangeColor = this.makeRangeColor(value,this.from.selected, this.to.selected, this.hoverDate);
                    arr.push({
                        text: i,
                        value: value,
                        state: state,
                        rangeColor:rangeColor
                    });
                    if(idx === 6) {
                        idx = 0;
                        rtn.push(arr);
                        arr = [];
                    } else {
                        idx++;
                    }
                }
                return [rtn, arr, idx];
            },
            makeNextDate(calendarMonth, flag, rtn, arr, idx) {
                // next month's first few days
                for(let i = idx; i<=6; i++) {
                    let tmp = new Date(calendarMonth[0],calendarMonth[1]-1+flag,i-idx+1);
                    let value = this.dateToYmd(tmp);
                    let state = 'next',rangeColor=[];
                    if(value < this.minDate) {state = 'disabled';}
                    if(this.maxDate < value) {state = 'disabled';}
                    if(flag ===1) {
                        state = 'invisible';
                    } else {
                        rangeColor = this.makeRangeColor(value,this.from.selected, this.to.selected, this.hoverDate);
                    }

                    arr.push({
                        text: tmp.getDate(),
                        value: value,
                        state: state,
                        rangeColor: rangeColor
                    });
                }
                rtn.push(arr);
                return rtn;
            },
            monthCalendar(calendarMonth,flag) {
                let rtn = [], arr = [], tmp;
                let idx;

                tmp = this.makePrevDate(calendarMonth, flag);
                idx = tmp[1];
                arr = tmp[0];

                tmp = this.makeCurrDate(calendarMonth, flag, arr, idx);
                rtn = tmp[0];
                arr = tmp[1];
                idx = tmp[2];
                if(idx === 0 ){
                    return rtn;
                }
                rtn = this.makeNextDate(calendarMonth, flag, rtn, arr, idx);
                return rtn;
            },
            makeRangeColor(val, frm, to, hov){
                let rtn = [];
                let ss=false,se=false,hs=false,he=false;
                // select color
                if(frm && to && frm<to) {
                    // from ~ to
                    if(frm<val && val<to) {rtn.push('select-between')}
                    else if(frm===val)    {rtn.push('select-start')}
                    else if(val===to)     {rtn.push('select-end')}
                }

                // hover color
                if(hov && frm && to) {
                    if( hov < frm ) { // hov << frm << to
                        // hover ~ from
                        checkHovVal(hov, frm)
                    } else if( to < hov ) { // frm << to << hov
                        // to ~ hover
                        checkHovVal(to, hov)
                    } else { // frm << hov << to
                        // hover ~ to
                        checkHovVal(hov, to)
                    }
                } else if( hov && frm && frm<hov){ // frm << hov << __
                    // from ~ hover
                    checkHovVal(frm, hov)
                } else if( hov &&  to && hov<to) { // ___ << hov << to
                    // hover ~ to
                    checkHovVal(hov, to)
                }
                // Local function :: for decrease Cognitive Complexity
                function checkHovVal(d1, d2) {
                    if(d1<val && val<d2) {rtn.push('hover-between')}
                    else if(d1===val)    {rtn.push('hover-start')}
                    else if(val===d2)    {rtn.push('hover-end')}
                }

                return rtn;
            },
            dateClass(date, dIdx) {
                let rtn = [];
                rtn.push('ur-date-picker__calendar__date');
                if(date.value === this.today) rtn.push('ur-date-picker__calendar__date--today');
                if(date.value === this.from.selected || date.value === this.to.selected) rtn.push('ur-date-picker__calendar__date--selected');
                if(date.value === this.hoverDate) rtn.push('ur-date-picker__calendar__date--hover');
                if(date.state === 'disabled') rtn.push('ur-date-picker__calendar__date--disabled');
                if(date.state === 'invisible') rtn.push('ur-date-picker__calendar__date--invisible');
                else if(date.state) rtn.push('ur-date-picker__calendar__date--other-month');
                rtn.push(this.weekDayClass(dIdx));
                return rtn;
            },
            weekDayClass(idx) {
                if(idx === this.sundayIdx) return 'ur-date-picker__calendar__date--sunday';
                if(idx === this.saturdayIdx) return 'ur-date-picker__calendar__date--saturday';
                return '';
            },
            resize(e){
                if(this.$refs.floating.isShow() === true){
                  this.$refs.floating.resize(e);
                }
            },
            isValidTimePattern(time) {
                let timePattern = /(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;
                return timePattern.test(time);
            },
        },
        provide() {
            let rtn = {};
            let odf = Object.defineProperty;
            let urInput = {};
            odf(urInput, 'size', {get: ()=>this.$_size});
            rtn['urInput'] = urInput;
            return rtn;
        },
        directives:  {
            'picker-click-outside': {
                inserted(el,binding, vnode) {
                    const handler = (e) => {
                        if (!(el.contains(e.target) || el === e.target)) {
                            binding.value(e)
                        }
                    };
                    el.__vueClickOutside__ = handler;
                    document.body.addEventListener('click', el.__vueClickOutside__);
                },
                unbind(el,binding,vnode) {
                    document.body.removeEventListener('click', el.__vueClickOutside__);
                    delete el.__vueClickOutside__;
                }
            }
        }
    }
</script>
